import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SearchSortFields } from 'api';
import { ProfilesWidget } from 'components';
import { people as peoplePath } from 'paths';
import { usePeopleSearch } from 'hooks';

const RecommendedPeople: FC = () => {
  const { t } = useTranslation();
  const { results } = usePeopleSearch({
    results_from: 0,
    size: 8,
    sort: SearchSortFields.CreatedAt,
  });

  return (
    <ProfilesWidget
      maxResults={8}
      maxWidth={170}
      results={results}
      link={peoplePath}
      title={t('components:recommendedPeople')}
    />
  );
};

export default RecommendedPeople;
